import { gql } from '@apollo/client';

export const GET_USER_REVIEWS = gql`
  query UserReviews($id: ID!, $limit: Int, $offset: Int) {
    user(id: $id) {
      reviewsList(limit: $limit, offset: $offset) {
        totalCount
        items {
          id
          rating
          comment
          createdAt
          tool {
            id
            name
          }
          createdByUser {
            id
            name
            avatarImageUrl
          }
        }
      }
    }
  }
`;
